import { getHeaders } from './xhrRequest';
import { createAction } from 'redux-api-middleware';

export const GET_AUTH_OPTION_INIT = 'GET_AUTH_OPTION_INIT';
export const GET_AUTH_OPTION_SUCCESS = 'GET_AUTH_OPTION_SUCCESS';
export const GET_AUTH_OPTION_FAILURE = 'GET_AUTH_OPTION_FAILURE';

export const getAuthOptions = () => createAction({
    types: [
        GET_AUTH_OPTION_INIT,
        {
            type: GET_AUTH_OPTION_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return {
                        ...json,
                        countries: json.countries.map(item => ({
                            value: item.label,
                            label: '+ '+item.value,
                            iso: item.label,
                            code: item.value,
                        })),
                    }
                });
            }
        },
        GET_AUTH_OPTION_FAILURE
    ],
    endpoint: `/api/auth-options/options`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
})
